export const OPEN_BALANCE_MODAL = 'open_balance_modal';
export const CLOSE_BALANCE_MODAL = 'close_balance_modal';
export const GET_BALANCE_DATA = "get_balance_data";
export const ADD_TRANSACTION = "add_transaction";
export const RESET_BALANCE = "reset_balance";
export const CHANGE_DISTRIBUTOR = "change_distributor";
export const GET_TRANSACTIONS = "get_transactions";
export const GET_DAILY_TRANSACTIONS = "get_daily_transactions";
export const SELECT_TRANSACTION = "select_transaction";
export const DELETE_TRANSACTION = "delete_transaction";
export const GET_MATERIAL_MEANS_REPORT = "get_material_means_report";
export const GET_SALARY_TRANSACTIONS = "get_salary_transaction";
export const ADD_SALARY_TRANSACTIONS = "add_salary_transaction";
export const DELETE_SALARY_TRANSACTIONS = "delete_salary_transaction"
